// frontend/src/pages/ForgotPasswordPage/ForgotPasswordPage.jsx
import React, { useState } from 'react';
import { Link } from 'react-router-dom'; // For "Back to Login" link
import styles from '../LoginPage/LoginPage.module.css'; // Shared auth page styles

import FormInput from '../../components/FormInput/FormInput';
import Button from '../../components/Button/Button';
import { requestPasswordReset } from '../../services/authService'; // Import the service



const ForgotPasswordPage = () => {
    const [username, setUsername] = useState('');
    const [message, setMessage] = useState(''); // For success messages
    const [error, setError] = useState('');   // For error messages
    const [loading, setLoading] = useState(false);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setMessage('');
        setError('');

        if (!username.trim()) {
            setError('Username is required.');
            return;
        }

        setLoading(true);
        try {
            const response = await requestPasswordReset({ username: username.trim() });
            // The backend will always send a generic success message.
            // Use the message from the backend if provided, or a default one.
            setMessage(response.message || 'If an account with that username exists and has a recovery email, a reset link has been sent.');
            setUsername(''); // Optionally clear the username field
        } catch (err) {
            // This catch block will typically handle network errors or if the service re-throws a generic error.
            // The backend itself doesn't reveal if the username was found or not via error status for this endpoint.
            setError(err.message || 'An error occurred. Please try again.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className={styles.authPage}> {/* Use consistent outer class name */}
            <div className={styles.authCard}> {/* Use consistent card class name */}
                <div style={{ padding: '10px 0', textAlign: 'center' }}>
                    <Link to="/login" className={styles.authLink}>← Back to Login</Link>
                </div>
                <div className={styles.authHeader}>
                    <h2 className={styles.authTitle}>Forgot Password</h2>
                    <p className={styles.authSubtitle}>
                        Enter your username. If an account exists with a linked recovery email, we'll send a reset link.
                    </p>
                </div>

                <div className={styles.authBody}>
                    {/* Use styles for consistency in message display until specific styles are made */}
                    {message && !error && <div className={styles.infoMessage}>{message}</div>}
                    {error && <div className={styles.errorMessage}>{error}</div>}

                    <form onSubmit={handleSubmit}>
                        <FormInput
                            label="Username:"
                            id="username"
                            name="username"
                            type="text"
                            value={username}
                            onChange={(e) => {
                                setUsername(e.target.value);
                                setError(''); // Clear error when user types
                                setMessage('');
                            }}
                            placeholder="Enter your username"
                            required
                            error={null} // Pass actual error string if you have per-field validation later
                            autoComplete="username"
                        />
                        <Button
                            type="submit"
                            variant="primary"
                            fullWidth
                            disabled={loading || !username.trim()}
                            style={{ marginTop: 'var(--space-md)' }} // Added margin similar to LoginPage
                        >
                            {loading ? 'Sending Link...' : 'Send Reset Link'}
                        </Button>
                    </form>
                </div>
            </div>
        </div>
    );
};

export default ForgotPasswordPage;